import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, filter, map } from 'rxjs/operators';
import { of, throwError } from 'rxjs';
import { AppStateService } from '@fb-tool-front/core/services';
import {
  BUSINESS_NOT_FOUND,
  FORBIDDEN_TEXT,
  FORBIDDEN_TYPE,
  TWO_FACTOR,
  UNAUTH_TYPE
} from '@fb-tool-front/shared/constants/shared.constant';
import { AuthService } from '../services/auth.service';
import { User } from '@fb-tool-front/shared/interfaces/auth.type';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class FacebookInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private appStateService: AppStateService,
    private translateService: TranslateService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: any) => {
        if (
          error instanceof HttpErrorResponse &&
          error.status === 403 &&
          !req.url.includes('api/facebook/user/me')
        ) {
          if (error.error.type === 'TiktokAuthRequireException') {
            return of(
              new HttpResponse({
                body: []
              })
            );
          }

          if (
            error.error?.error?.type === FORBIDDEN_TYPE ||
            (error.statusText === FORBIDDEN_TEXT &&
              error.error?.error?.type !== UNAUTH_TYPE &&
              error.error?.error?.type !== BUSINESS_NOT_FOUND &&
              error.error?.error?.type !== TWO_FACTOR)
          ) {
            this.appStateService.navigateToError({
              severity: 'error',
              message: error.error?.error?.message || this.translateService.instant('Access denied')
            });
          }

          if (
            (this.authService.user$$.getValue() as User)?.impersonated &&
            error.error?.error?.type === UNAUTH_TYPE
          ) {
            this.appStateService.navigateToError({
              severity: 'error',
              message: this.translateService.instant(
                'Impersonated user does not have Facebook token'
              )
            });
          }
        }

        return throwError(error);
      })
    );
  }
}
